import { PRODUCT_LISTING_SET_PROP } from '../constants';
import { get, post } from '../Services/http';

export const setProductListingType = (productListingType) => async (
  dispatch
) => {
  const res = await post('/api/products/listingtype', {
    productListingType,
  });
  if (res.ok) {
    dispatch(setProductListingProp('productListingType', productListingType));
  }
};

const setProductListingProp = (key, value) => ({
  type: PRODUCT_LISTING_SET_PROP,
  payload: {
    [key]: value,
  },
});
